export function formatTime(timeString) {
  if (!timeString) return '';
  // Parse time string, which may be in HH:mm:ss or HH:mm format
  const parts = timeString.split(':');
  if (parts.length < 2) return timeString; // return as is if format unexpected
  return parts[0].padStart(2, '0') + ':' + parts[1].padStart(2, '0');
}
